import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ResourceLinks from './ResourceLinks';


// Fullscreen dialog for the clicked image
const FullScreenImageDialog = ({ open, imageUrl, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogContent>
        <img src={imageUrl} alt="Full size" style={{ width: '100%', height: 'auto' }} />
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogContent>
    </Dialog>
  );
};

const ProjectModal = ({ open, onClose, project }) => {
  const [fullScreenImage, setFullScreenImage] = useState(null);

  if (!project) return null;

  // Open the full-screen dialog for the clicked image
  const handleImageClick = (imageUrl) => {
    setFullScreenImage(imageUrl);
  };

  const handleFullScreenClose = () => {
    setFullScreenImage(null);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            backgroundColor: 'rgba(15, 23, 42, 0.95)',
            borderRadius: 4,
            border: '1px solid rgba(148, 163, 184, 0.25)',
            boxShadow: '0 45px 90px rgba(15, 23, 42, 0.45)',
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h5" fontWeight="bold" sx={{ paddingLeft: '1rem' }}>
            {project.title}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ color: 'text.secondary' }}>
          <Typography variant="body1" paragraph sx={{ paddingLeft: '1rem' }}>
            {project.description}
          </Typography>
          <ResourceLinks
            slides={project.slides}
            media={project.media}
            document={project.document}
            certificate={project.certificate}
            poster={project.poster}
            doi={project.doi}
          />

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mt: 3,
              overflowX: 'auto',
              pb: 1,
              px: 1,
              scrollSnapType: 'x mandatory',
            }}
          >
            {project.gallery?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: '0 0 220px',
                  height: 220,
                  borderRadius: 3,
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  backgroundColor: 'rgba(15, 23, 42, 0.6)',
                  border: '1px solid rgba(148, 163, 184, 0.2)',
                  scrollSnapAlign: 'center',
                }}
              >
                <img
                  src={item.original}
                  alt=""
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                  onClick={() => handleImageClick(item.original)}
                />
                <IconButton
                  onClick={() => handleImageClick(item.original)}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    backgroundColor: 'rgba(2, 6, 23, 0.7)',
                    color: 'white',
                  }}
                >
                  <ZoomInIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </DialogContent>
      </Dialog>

      {/* Fullscreen image dialog */}
      {fullScreenImage && (
        <FullScreenImageDialog open={!!fullScreenImage} imageUrl={fullScreenImage} onClose={handleFullScreenClose} />
      )}
    </>
  );
};

export default ProjectModal;
